{#if $isUserLoggedIn}
  {#if $bubbleTimelineEnabled}
    <TimelinePage timeline="bubble">
      {#if $pinnedPage !== '/bubble'}
        <DynamicPageBanner title="{"Bubble timeline"}" icon="#fa-circle"/>
      {/if}
    </TimelinePage>
  {:else}
    <FreeTextLayout>
      <h1>{"Bubble"}</h1>

      <p>{"The bubble timeline isn't supported by your instance."}</p>
    </FreeTextLayout>
  {/if}
{:else}
  <HiddenFromSSR>
    <FreeTextLayout>
      <h1>{"Bubble"}</h1>

      <p>{"Your bubble timeline will appear here when logged in."}</p>
    </FreeTextLayout>
  </HiddenFromSSR>
{/if}
<script>
  import TimelinePage from '../_components/TimelinePage.html'
  import FreeTextLayout from '../_components/FreeTextLayout.html'
  import { store } from '../_store/store.js'
  import HiddenFromSSR from '../_components/HiddenFromSSR.html'
  import DynamicPageBanner from '../_components/DynamicPageBanner.html'

  export default {
    store: () => store,
    components: {
      TimelinePage,
      FreeTextLayout,
      HiddenFromSSR,
      DynamicPageBanner
    }
  }
</script>
